import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { StakeholderType } from '@types';

export type PatchStakeholderRequest = {
	alertMetadataChanges?: boolean;
	email?: string;
	name?: string;
	stakeholderId: number;
	stakeholderType?: StakeholderType;
};

export const patchStakeholder = createPatchEndpoint<PatchStakeholderRequest, void>(
	(request) => `/api/v3/core/stakeholders/${request.stakeholderId}`,
	{
		requestTransform: ({ stakeholderId, ...rest }) => ({ ...rest })
	}
);
